import type { PaymentMethodDetails } from '@lucidtech/las-sdk-browser';
import { memo } from 'react';

import { merge } from '@/components';
import { Text } from '@/components/core';
import { CreditCardLogo } from '@/components/logos';
import { DivProps } from '@/utils';

export type CreditCardProps = Omit<DivProps, 'children'> & {
  details?: PaymentMethodDetails | null;
};

const ICreditCard = ({ className, details, ...rest }: CreditCardProps) => {
  if (!details) return;

  return (
    <div className={merge('flex items-center gap-4 py-2', className)} {...rest}>
      <CreditCardLogo className="size-12" brand={details.brand} />
      <div className="flex flex-col">
        <Text>Credit card ending in {details.last4}</Text>
        <Text>
          Expires {details.expMonth}/{details.expYear}
        </Text>
      </div>
    </div>
  );
};

export const CreditCard = memo(ICreditCard) as typeof ICreditCard;
